import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import dsLogo from "../images/ds-logo-enhanced.png";

const navItems = [
  { label: "Home", to: "/" },
  { label: "Solutions", to: "/solutions" },
  { label: "Industries", to: "/industries" },
  { label: "OEM Manufacturing", to: "/oem-manufacturing" },
  { label: "Porcelain Tiles", to: "/porcelain-tiles" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const linkClass = ({ isActive }) =>
    `px-2 py-2 text-sm font-medium transition ${isActive ? "text-[#b8894d]" : "text-slate-200 hover:text-white"}`;

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#07111f]/95 text-white backdrop-blur">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-3" onClick={() => setMobileOpen(false)}>
          <span className="grid h-10 w-10 place-items-center overflow-visible"><img src={dsLogo} alt="DS Global Machines logo" className="max-h-9 w-auto object-contain" /></span>
          <span className="text-base font-semibold tracking-wide sm:text-lg">DS Global Machines</span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary navigation">
          {navItems.map((item) => <NavLink key={item.to} to={item.to} className={linkClass}>{item.label}</NavLink>)}
          <Link to="/contact/rfq" className="ml-3 rounded bg-white px-4 py-2 text-sm font-semibold text-[#07111f] transition hover:bg-[#d6ad73]">Request a Quote</Link>
        </nav>

        <button type="button" className="grid h-10 w-10 place-items-center rounded border border-white/15 text-white lg:hidden" aria-label="Toggle menu" aria-expanded={mobileOpen} onClick={() => setMobileOpen((value) => !value)}>
          {mobileOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {mobileOpen && (
        <nav className="border-t border-white/10 bg-[#07111f] px-6 pb-6 lg:hidden" aria-label="Mobile navigation">
          <div className="mx-auto grid max-w-7xl gap-1 pt-4">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className="rounded px-3 py-3 text-sm font-medium text-slate-200 hover:bg-white/5" onClick={() => setMobileOpen(false)}>{item.label}</NavLink>
            ))}
            <Link to="/contact/rfq" className="mt-3 rounded bg-[#b8894d] px-4 py-3 text-center text-sm font-semibold text-white" onClick={() => setMobileOpen(false)}>Request a Quote</Link>
          </div>
        </nav>
      )}
    </header>
  );
}









